import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import "./LoginPage.css";

interface LoginPageProps {
  onLoginSuccess?: () => void;
}

export const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  const { login } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setError(null);
      setSubmitting(true);
      await login(email, password);
      onLoginSuccess?.();
    } catch (error) {
      // サーバーの文言（ロックの案内・試行回数の制限を含む）をそのまま出す
      setError(error instanceof Error ? error.message : "ログインに失敗しました。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>管理者ログイン</h1>
          <p>メールアドレスとパスワードでログインしてください</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">メールアドレス</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">パスワード</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="パスワードを入力"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? "ログイン中..." : "ログイン"}
          </button>
        </form>

        <div className="login-footer">
          <p>
            アクセス権限がない場合は、管理者にお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};
